import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isMobileMode } = {}) => ({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginInline: isMobileMode ? '-12px' : '-20px',
    marginTop: isMobileMode ? '-12px' : '-20px',
    paddingInline: isMobileMode ? '12px' : '20px',
    paddingTop: isMobileMode ? '12px' : '20px',
    paddingBottom: '50px',
  },
  kitsQtyLabel: {
    marginBottom: theme.spacing(2),
  },
}));
